import React, { useState, useEffect } from "react";
import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "./components/home/home";
import Login from "./components/login/login";
import Splash from "./components/splash/splash";
import Otp from "./components/otp/otp";
// ProtectedRoute is removed for direct route logic handling
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  
  // State initialization from localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );
  const [isOtpVerified, setIsOtpVerified] = useState(
    localStorage.getItem("isOtpVerified") === "true"
  );

  useEffect(() => {
    // Simulate loading time
    setTimeout(() => {
      setIsLoading(false);
    }, 50); 
    
    // Function to read localStorage and update React State
    const updateAuthState = () => {
      const newIsLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      const newIsOtpVerified = localStorage.getItem("isOtpVerified") === "true";
      
      // Update state only if values have changed
      if (newIsLoggedIn !== isLoggedIn) {
          setIsLoggedIn(newIsLoggedIn);
      }
      if (newIsOtpVerified !== isOtpVerified) {
          setIsOtpVerified(newIsOtpVerified);
      }
    };
    
    // Listen for storage changes from other tabs (standard event)
    window.addEventListener("storage", updateAuthState);
    // Listen for the custom event dispatched from Login/Otp components
    window.addEventListener("authUpdate", updateAuthState);

    // Initial check in case state was missed during mount
    updateAuthState();

    return () => {
        window.removeEventListener("storage", updateAuthState);
        window.removeEventListener("authUpdate", updateAuthState);
    };

  }, [isLoggedIn, isOtpVerified]); // Depend on state to re-run effects properly

  if (isLoading) return null;

  return (
    <div
      className="App"
      style={{
        visibility: isLoading ? "hidden" : "visible",
        opacity: isLoading ? 0 : 1,
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Splash />} />

          {/* 1. LOGIN Route: If verified, redirect to Home. */}
          <Route 
             path="/login" 
             element={
                isLoggedIn && isOtpVerified ? <Navigate to="/home" replace /> : <Login />
             } 
          />
          
          {/* 2. OTP Route: Controlled access based on auth status */}
          <Route
            path="/otp"
            element={
                !isLoggedIn ? (
                    <Navigate to="/login" replace />
                ) : isOtpVerified ? (
                    <Navigate to="/home" replace />
                ) : (
                    <Otp onOtpVerified={() => setIsOtpVerified(true)} />
                )
            }
          />

          {/* 3. HOME Route: Protected route */}
          <Route
            path="/home"
            element={
                !isLoggedIn ? (
                    <Navigate to="/login" replace />
                ) : !isOtpVerified ? (
                    <Navigate to="/otp" replace />
                ) : (
                    <Home />
                )
            }
          />

        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </div>
  );
}

export default App;